module.exports = __webpack_public_path__ + "assets/media/bolt-trio-teal.65411055.svg";